import DetailStatTiles, { StatTile } from "@/app/admin/_common/DetailStatTiles";
import type { AutomationStats } from "../automationDetailPageModel";

export default function AutomationStatTiles({ stats }: { stats: AutomationStats | null }) {
  const window = stats?.window_days ?? 30;

  const tiles: StatTile[] = [
    {
      label: "Runs",
      value: String(stats?.total ?? 0),
      caption: `last ${window} days`,
    },
    {
      label: "Sent",
      value: String(stats?.completed ?? 0),
    },
    {
      // Skips are not failures — shadow mode and unmet conditions both land here — but
      // a number that is unexpectedly high is the main signal that an automation is
      // configured wrongly, so it gets equal billing rather than being hidden.
      label: "Skipped",
      value: String(stats?.skipped ?? 0),
    },
    {
      label: "Failed",
      value: String(stats?.failed ?? 0),
    },
  ];

  return <DetailStatTiles tiles={tiles} columns={4} />;
}
